import React, { Component } from 'react';
import { withStyles, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';

// sample text halasz privacy policy
const PrivacyText = `<Div >

1. 개인정보 수집목적 및 이용목적<br /><br />

가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산<br />
콘텐츠 제공 , 구매 및 요금 결제 , 물품배송 또는 청구지 등 발송 , 금융거래 본인 인증 및 금융 서비스<br /><br />

나. 회원 관리 회원제 서비스 이용에 따른 본인확인 , 개인 식별 , 불량회원의 부정 이용 방지와 비인가 사용 방지 , 가입 의사 확인 , 연령확인 , 만14세 미만 아동<br />
개인정보 수집 시 법정 대리인 동의여부 확인, 불만처리 등 민원처리 , 고지사항 전달<br /><br /><br />


2. 수집하는 개인정보 항목<br /><br />

이름, 이메일, 비밀번호 외<br /><br /><br />


3. 개인정보의 보유기간 및 이용기간<br /><br />

원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.<br />
단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.<br /><br />

가. 회사 내부 방침에 의한 정보 보유 사유<br /><br />

o 부정거래 방지 및 쇼핑몰 운영방침에 따른 보관 : 5년<br /><br />

나. 관련 법령에 의한 정보보유 사유<br /><br />

o 계약 또는 청약철회 등에 관한 기록<br /><br />

-보존이유 : 전자상거래등에서의 소비자보호에 관한 법률<br /><br />

-보존기간 : 5년<br /><br />

o 대금 결제 및 재화 등의 공급에 관한 기록<br /><br />

-보존이유: 전자상거래등에서의 소비자보호에 관한 법률<br /><br />

-보존기간 : 5년<br /><br />

o 소비자 불만 또는 분쟁처리에 관한 기록<br /><br />

-보존이유 : 전자상거래등에서의 소비자보호에 관한 법률<br /><br />

-보존기간 : 3년<br /><br />

o 로그 기록<br /><br />

-보존이유: 통신비밀보호법<br /><br />

-보존기간 : 3개월
</Div>`;

const styles = (theme) => ({});

class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = { matches: window.matchMedia('(max-width:600px)').matches };
  }
  render() {
    const { open, onClose } = this.props;
    return (
      <Grid container>
        <Dialog
          fullWidth={true}
          maxWidth={'xs'}
          onClose={onClose}
          open={open}
          style={this.state.match ? {} : { marginTop: '6%', marginLeft: '2.5%', height: '75vh' }}
        >
          <DialogTitle>
            <Grid container item xs={12}>
              <Grid container item xs={1}></Grid>
              <Grid container item xs={10} alignContent="center" justify="center">
                <b>개인정보 처리방침</b>
              </Grid>
              <Grid container item xs={1}>
                <IconButton onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <Grid container justify="center" style={{ padding: '2vh 2vw' }}>
              <div dangerouslySetInnerHTML={{ __html: PrivacyText }} />
            </Grid>
          </DialogContent>
        </Dialog>
      </Grid>
    );
  }
}

export default withStyles(styles)(PrivacyPolicy);
